import Loadable from 'react-loadable';

import { FooterTheme } from '@rover/kibble/styles';
import Route from '@rover/types/src/Route';
import { LEFT_NAV_BAR_ITEMS } from '@rover/react-lib/src/constants/navBar.constants';
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import retry from '@rover/rsdk/src/modules/Network/retry';

import Loading from '../client/Loading';

const SearchPage = Loadable({
  loader: () =>
    retry(
      () =>
        import(/* webpackChunkName: "SearchPage" */ '@rover/react-lib/src/pages/search/SearchPage')
    ),
  loading: Loading,
});

const routes: Route[] = [
  {
    path: '/search',
    component: SearchPage,
    componentName: 'SearchPage',
    exact: true,
  },
].map((route) => ({
  ...route,
  concept: CONCEPTS.recommendations.browse_search,
  pageCategory: 'search',
  pageName: 'search',
  footerTheme: FooterTheme.LIGHT,
  leftNavBarItems: [
    LEFT_NAV_BAR_ITEMS.BECOME_A_SITTER_LINK,
    LEFT_NAV_BAR_ITEMS.REFER_LINK,
    LEFT_NAV_BAR_ITEMS.OUR_SERVICES_LINK,
  ],
  navBarIsFullWidth: true,
  cacheTag: ['page-search', 'page-all'],
  isReactQueryRoute: false,
}));

export default routes;
